import React, { useState } from 'react';
import {
  TextField,
  Grid,
  MenuItem,
  Switch,
  FormControlLabel,
  Button,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import api from './api';

const s3_product_url = 'https://d6-halo.s3.amazonaws.com/static/media/products/';

const ProductForm = ({ product, setProduct, categories, refetch, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      const file = files[0];
      setProduct((prev) => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file),
      }));
    } else if (type === 'checkbox') {
      setProduct((prev) => ({ ...prev, [name]: checked }));
    } else {
      setProduct((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleQuillChange = (field, value) => {
    setProduct((prev) => ({ ...prev, [field]: value }));
  };
console.log(product)
  const handleSubmit = async () => {
    const required = ['category', 'name', 'price', 'origPrice', 'description'];
    const missing = required.filter((f) => !product[f]?.toString().trim());

    if (missing.length > 0) {
      toast.error(`Missing: ${missing.join(', ')}`);
      return;
    }

    if (!product.id && (!product.image || !product.image.name)) {
      toast.error(`Image is required`);
      return;
    }

    if (Number(product.price) > Number(product.origPrice)) {
      toast.error(`Discounted price should be less than original price`);
      return;
    }

    const formData = new FormData();
    Object.entries(product).forEach(([key, value]) => {
      if (key === 'imagePreview') return;
      if (key === 'image') {
        if (value && value.name) {
          formData.append('image', value);
        }
      } else {
        formData.append(key, value);
      }
    });

    setLoading(true);
    try {
      if (product.id) {
        formData.append('id', product.id);
        formData.append('category_id', product.category);
        await api.put('product-v2', formData);
        toast.success('Product updated');
      } else {
        await api.post('product-v2', formData);
        toast.success('Product created');
      }

      refetch?.();
      onSuccess?.();
    } catch (err) {
      console.error(err);
      toast.error('Error saving product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container style={{ width: '100%' }} spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'right' }}>
          <FormControlLabel
            control={
              <Switch
                checked={product.active}
                onChange={handleChange}
                name="active"
                color="primary"
              />
            }
            label="Active"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Category"
            name="category"
            value={product.category}
            onChange={handleChange}
          >
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Product Name"
            name="name"
            value={product.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="WhatsApp"
            name="whatsapp"
            value={product.whatsapp}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Link to share"
            name="share"
            value={product.share}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Description"
            name="description"
            value={product.description}
            onChange={handleChange}
          />
        </Grid>

        {/* Additional Info - Quill Editor */}
        <Grid item xs={12}>
          <label style={{ fontWeight: 500, marginBottom: 8, display: 'block' }}>
            Additional Info
          </label>
          <ReactQuill
            theme="snow"
            
            value={product.additionalInfo || ''}
            onChange={(val) => handleQuillChange('additionalInfo', val)}
            style={{ background: '#fff',height:'25vh' ,paddingBottom:40}}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="number"
            label="Original Price"
            name="origPrice"
            value={product.origPrice}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="number"
            label="Discounted Price"
            name="price"
            value={product.price}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />
        </Grid>

        {(product.imagePreview || typeof product.image === 'string') && (
          <Grid item xs={12}>
            <img
              src={
                product.imagePreview ||
                (typeof product.image === 'string'
                  ? s3_product_url + product.image
                  : '')
              }
              alt="Preview"
              style={{ maxWidth: '100%', maxHeight: 200, marginTop: 10 }}
            />
          </Grid>
        )}

          <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="number"
            label="Priority"
            name="priority"
            value={product.priority}
            onChange={handleChange}


          />
          </Grid>
      </Grid>

      <Button
        onClick={handleSubmit}
        variant="contained"
        color="primary"
        disabled={loading}
        style={{ marginTop: 16 }}
      >
        {loading ? 'Saving...' : product.id ? 'Update Product' : 'Create Product'}
      </Button>
    </>
  );
};

export default ProductForm;
